import JSZip from "jszip";
import React, { useState } from "react";
import { Button, Box, Typography, Stack } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";

function UpdateQuestionnaireTests({ sendQuestionnaireTestsFunction }) {
  const [content, setContent] = useState(null);
  const [fileName, setFileName] = useState("");

  const handleFileChange = event => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    setFileName(selectedFile.name);
    const reader = new FileReader();
    reader.onload = event => {
      const zip = new JSZip();
      zip.loadAsync(event.target.result).then(zipContent => {
        setContent(zipContent);
      });
    };
    reader.readAsArrayBuffer(selectedFile);
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (content) {
      sendQuestionnaireTestsFunction(content);
    }
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Button
        variant="outlined"
        component="label"
        startIcon={<UploadFileIcon />}
      >
        Select Questionnaire ZIP
        <input
          type="file"
          hidden
          onClick={e => (e.target.value = null)}
          onChange={handleFileChange}
          accept=".zip"
        />
      </Button>
      <Typography variant="body2" color="textSecondary">
        {fileName || "No file selected"}
      </Typography>
      <Button
        type="button"
        variant="contained"
        disabled={!content}
        onClick={handleSubmit}
        color="primary"
      >
        Update Questionnaire
      </Button>
    </Stack>
  );
}

export default UpdateQuestionnaireTests;
